import { ITag } from "../interfaces/Tag";

export const C128 = "C128";
export const C128_GS1 = "C128_GS1";
export const C39 = "C39";
export const EAN13 = "EAN13";
export const QR = "QR";
export const DATAMATRIX = "DATAMATRIX";
export const DATAMATRIX_GS1 = "DATAMATRIX_GS1";
export const ITF14 = "ITF14";

export const barcodeTypes = [
  { key: C128, text: "Code 128", value: C128 },
  { key: C128_GS1, text: "C128 (GS1)", value: C128_GS1 },
  { key: C39, text: "Code 39", value: C39 },
  { key: EAN13, text: "EAN13", value: EAN13 },
  { key: QR, text: "QR code", value: QR },
  { key: DATAMATRIX, text: "Data Matrix", value: DATAMATRIX },
  { key: DATAMATRIX_GS1, text: "Data Matrix (GS1)", value: DATAMATRIX_GS1 },
  { key: ITF14, text: "ITF14", value: ITF14 },
];
export const getBarcodeDefaultValue = (barcodeTagList: ITag[], id: any) => {
  return barcodeTagList.find((tag) => tag.id === id)?.defaulttext;
};

export const dataMatrixSizes = [
  { key: "Auto", text: "Auto", value: "Auto" },
  { key: "10x10", text: "10x10", value: "10x10" },
  { key: "12x12", text: "12x12", value: "12x12" },
  { key: "14x14", text: "14x14", value: "14x14" },
  { key: "16x16", text: "16x16", value: "16x16" },
  { key: "18x18", text: "18x18", value: "18x18" },
  { key: "20x20", text: "20x20", value: "20x20" },
  { key: "22x22", text: "22x22", value: "22x22" },
  { key: "24x24", text: "24x24", value: "24x24" },
  { key: "26x26", text: "26x26", value: "26x26" },
  { key: "32x32", text: "32x32", value: "32x32" },
  { key: "36x36", text: "36x36", value: "36x36" },
  { key: "40x40", text: "40x40", value: "40x40" },
  { key: "44x44", text: "44x44", value: "44x44" },
  { key: "48x48", text: "48x48", value: "48x48" },
  { key: "52x52", text: "52x52", value: "52x52" },
  { key: "64x64", text: "64x64", value: "64x64" },
  { key: "72x72", text: "72x72", value: "72x72" },
  { key: "80x80", text: "80x80", value: "80x80" },
  { key: "88x88", text: "88x88", value: "88x88" },
  { key: "96x96", text: "96x96", value: "96x96" },
  { key: "104x104", text: "104x104", value: "104x104" },
  { key: "120x120", text: "120x120", value: "120x120" },
  { key: "132x132", text: "132x132", value: "132x132" },
  { key: "144x144", text: "144x144", value: "144x144" },
  { key: "8x18", text: "8x18", value: "8x18" },
  { key: "8x32", text: "8x32", value: "8x32" },
  { key: "12x26", text: "12x26", value: "12x26" },
  { key: "12x36", text: "12x36", value: "12x36" },
  { key: "16x38", text: "16x38", value: "16x38" },
  { key: "16x48", text: "16x48", value: "16x48" },
  ];

